import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-regular-svg-icons';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons';
import styles from './Audience.module.scss';

export const CheckIcon: React.FC<{ checked: boolean }> = ({ checked }) => (
    <FontAwesomeIcon
        icon={checked ? faSquareCheck : faSquare}
        className={clsx(styles.check, { [styles.checkOn]: checked })}
    />
);

export default CheckIcon;
